import { render, staticRenderFns } from "./downloadEventCerticifates.vue?vue&type=template&id=3f1540db&scoped=true"
import script from "./downloadEventCerticifates.vue?vue&type=script&lang=js"
export * from "./downloadEventCerticifates.vue?vue&type=script&lang=js"
import style0 from "./downloadEventCerticifates.vue?vue&type=style&index=0&id=3f1540db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1540db",
  null
  
)

export default component.exports